<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-3">
                                        <b-form-input
                                            v-model="filter"
                                            class="form-control"
                                            type="search"
                                            :placeholder="$t('label.search')"
                                            v-on:change="searchListing"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <div class="col-md-8"></div>
                                    <div class="col-md-1 d-flex justify-content-end align-items-center">
                                        <b-button
                                            variant="secondary"
                                            class="mr-1"
                                            @click="searchListing"
                                            :disabled="!status.list && loading"
                                            :title="$t('label.refresh')"
                                            v-b-tooltip:hover
                                        >
                                            <i class="mdi mdi-refresh"></i>
                                        </b-button>
                                        <b-dropdown
                                            variant="warning"
                                            no-caret
                                            right
                                            menu-class="dropdown-menu-250"
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-filter"></i>
                                            </template>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    Event
                                                </label>
                                                <multiselect
                                                    v-model="eventFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="eventDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    User
                                                </label>
                                                <multiselect
                                                    v-model="userFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="userDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                        </b-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                v-if="status.list && !loading"
                                :items="tableRows"
                                :fields="fields"
                                :per-page="perPage"
                                responsive="sm"
                            >
                                <template #cell(user)="data">
                                    <span>{{ data.item.user ? data.item.user.firstName + ' ' + data.item.user.lastName : '--' }}</span>
                                </template>
                                <template #cell(log_name)="data">
                                    <span>{{ data.item.log_name ? data.item.log_name : '--' }}</span>
                                </template>
                                <template #cell(event)="data">
                                    <b-badge :variant="getEventVariant(data.item.event)">{{ data.item.event || '--' }}</b-badge>
                                </template>
                                <template #cell(description)="data">
                                    <span>{{ data.item.description ? data.item.description : '--' }}</span>
                                </template>
                                <template #cell(subjectType)="data">
                                    <span>{{ data.item.subjectType ? data.item.subjectType : '--' }}</span>
                                </template>
                                <template #cell(actions)="data">
                                    <a
                                        href="javascript:void(0);"
                                        :class="[data.item.requestLog ? 'text-warning' : 'text-secondary']"
                                        v-b-tooltip.hover
                                        :title="$t('module.requestLog')"
                                        v-on:click="data.item.requestLog ? openRequestLog(data.item) : ''"
                                    >
                                        <i class="mdi mdi-web font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info ml-1"
                                        v-b-tooltip.hover
                                        :title="$t('label.detail')"
                                        v-on:click="openForm(data.item)"
                                    >
                                        <i class="mdi mdi-eye font-size-18"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list && !loading"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                        <div v-if="totalPage" class="d-flex flex-column flex-md-row justify-content-md-between align-items-center">
                            <small class="text-muted">{{ $t('label.total') }}: {{ totalPage }}</small>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalPage"
                                :per-page="perPage"
                                v-on:change="pageNavigation"
                                variant="info"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="activity-log-form"
            :title="$t('label.viewX', [$t('module.activityLog')])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            size="xl"
            centered
        >
            <b-container fluid>
                <ActivityLogForm
                    :activityLog="activityLog"
                    @done="closeForm"
                    ref="activityLogForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="activity-request-log-form"
            :title="$t('label.viewX', [$t('module.requestLog')])"
            @hidden="closeRequestLog"
            hide-footer
            hide-header-close
            size="xl"
            centered
        >
            <b-container fluid>
                <RequestLogForm
                    :requestLog="requestLog"
                    @done="closeRequestLog"
                    ref="requestLogForm"
                />
            </b-container>
        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import i18n from "@/i18n";
import { SESSION, SHARED } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { activityLogMethods, lookupMethods } from "@/state/api";
import { ACTIVITY_LOG_MODULE } from "@/state/api/activityLog.state";
import ActivityLogForm from "@/views/pages/admin/diagnostic/activityLog/activityLogForm";
import RequestLogForm from "@/views/pages/admin/diagnostic/requestLog/requestLogForm";

export default {
    components: { Multiselect, ActivityLogForm, RequestLogForm },
    async created() {
        await this.lookupUser({});

        sessionHelper.clearSearch(SESSION.ACTIVITY_LOG_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();

        this.loading = false;
    },
    data() {
        return {
            filter: "",
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            eventDdl: [
                ddlHelper.getOptionAll(),
                { value: 'created', text: 'created' },
                { value: 'updated', text: 'updated' },
                { value: 'deleted', text: 'deleted' },
            ],
            eventFilter: ddlHelper.getOptionAll(),
            userFilter: null,
            fields: [
                { key: 'createdAt', label: i18n.t("label.createdAt"), sortable: true, class: 'text-nowrap' },
                { key: 'user', label: 'User', sortable: true, class: 'text-nowrap' },
                { key: 'log_name', label: 'Log Name', sortable: true, class: 'text-nowrap' },
                { key: 'event', label: 'Event', sortable: true, class: 'text-nowrap' },
                { key: 'description', label: 'Description', sortable: true, class: '' },
                { key: 'subjectType', label: 'Subject Type', sortable: true, class: 'text-nowrap' },
                { key: 'actions', label: i18n.t("label.action"), sortable: false, class: 'text-nowrap' },
            ],
            searchCriteria: {},
            activityLog: this.defaultActivityLog(),
            requestLog: this.defaultRequestLog(),
            loading: true,
        };
    },
    methods: {
        ...activityLogMethods,
        ...lookupMethods,
        defaultRequestLog() {
            return {
                uuid: "",
                method: "",
                path: "",
                files: null,
                requestPayload: null,
                responsePayload: null,
                ip: "",
                url: "",
                scheme: "",
                host: "",
                port: "",
                cookies: null,
                userAgent: "",
                statusCode: "",
                success: false,
                performance: null,
                createdAt: "",
                updatedAt: "",
                user: null,
                errorLog: null,
            };
        },
        defaultActivityLog() {
            return {
                uuid: "",
                log_name: "",
                event: "",
                description: "",
                subjectType: "",
                subjectId: "",
                causerType: "",
                properties: null,
                performance: null,
                oldValues: null,
                newValues: null,
                createdAt: "",
                updatedAt: "",
                user: null,
                requestLog: null,
            };
        },
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.ACTIVITY_LOG_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.ACTIVITY_LOG_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if(isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    searchValue: "",
                    searchArray: [],
                };
            }
            this.getActivityLogList(this.searchCriteria);
        },
        getActivityLogList(filter) {
            this.getAllActivityLog({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.ACTIVITY_LOG_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.ACTIVITY_LOG_SEARCH);
            filter.pageNumber = pageNumber;
            this.getActivityLogList(filter);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            if (this.eventFilter?.value == SHARED.DEFAULT_ALL_VALUE)
                delete this.searchCriteria.event;
            else if (this.eventFilter?.value)
                this.searchCriteria.event = this.eventFilter.value;

            if (this.userFilter?.value == SHARED.DEFAULT_ALL_VALUE)
                delete this.searchCriteria.user;
            else if (this.userFilter?.value)
                this.searchCriteria.user = this.userFilter.value;

            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getActivityLogList(this.searchCriteria);
        },
        openForm(data) {
            if (data?.uuid) {
                this.activityLog = {
                    ...this.defaultActivityLog(),
                    ...data,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('activity-log-form');
            });
        },
        closeForm() {
            this.activityLog = this.defaultActivityLog();
            this.$bvModal.hide('activity-log-form');
        },
        openRequestLog(data) {
            if (data?.requestLog) {
                this.requestLog = {
                    ...this.defaultRequestLog(),
                    ...data.requestLog,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('activity-request-log-form');
            });
        },
        closeRequestLog() {
            this.requestLog = this.defaultRequestLog();
            this.$bvModal.hide('activity-request-log-form');
        },
        getEventVariant(event) {
            if(event == 'created') return 'success';
            if(event == 'updated') return 'warning';
            if(event == 'deleted') return 'danger';
            return 'secondary';
        },
    },
    computed: {
        ...mapState(ACTIVITY_LOG_MODULE, ['status']),
        userDdl() {
            return [
                ddlHelper.getOptionAll(),
                ...this.$store.state.api.lookup.userDdl,
            ];
        },
        tableRows() {
            return this.$store.state.api.activityLog.list.data || [];
        },
        totalPage() {
            return this.$store.state.api.activityLog.list.pagination.total || 0;
        },
    },
}
</script>
